export const generatePlaceholderImage = (width, height, text) => {
  // Create a canvas element
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  
  // Get the drawing context
  const ctx = canvas.getContext('2d');
  
  // Fill background
  ctx.fillStyle = '#f5f5f5';
  ctx.fillRect(0, 0, width, height);
  
  // Add text
  ctx.fillStyle = '#666666';
  ctx.font = `16px Arial`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  
  // Wrap text if too long
  const words = text.split(' ');
  const lines = [];
  let currentLine = words[0];

  for (let i = 1; i < words.length; i++) {
    const word = words[i];
    const width = ctx.measureText(currentLine + " " + word).width;
    if (width < canvas.width - 20) {
      currentLine += " " + word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  }
  lines.push(currentLine);

  // Draw wrapped text
  lines.forEach((line, i) => {
    const y = height/2 - ((lines.length - 1) * 20)/2 + i * 20;
    ctx.fillText(line, width/2, y);
  });

  // Convert to base64
  return canvas.toDataURL('image/png');
}; 